import Component from '@ember/component';
import { get, getProperties, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';

/* attrs
  - reportChangeset
  - field
  - individual
  - checkForErrors
    - number that increments when the component should check for errors
*/
export default Component.extend({
  abilities: service(),
  coachingService: service(),

  reportChangeset: null,
  field: null,
  individual: null,

  canEditGoal: computed('field.t', function () {
    if (this.abilities.noCoachingAbility('edit_goal')) {
      return false;
    }
    let fieldType = get(this, 'field.t');
    return (
      get(this, 'coachingService.overallGoalTypes')[fieldType] ||
      get(this, 'coachingService.intervalGoalTypes')[fieldType] ||
      false
    );
  }),

  showPrevVal: computed('reportChangeset.id', 'field.id', function () {
    let fieldType = get(this, 'field.t');
    return (
      fieldType !== 'string' &&
      fieldType !== 'tasks' &&
      fieldType !== 'response' &&
      this.prevReport != null
    );
  }),

  prevReport: computed('reportChangeset.id', function () {
    let { reportChangeset, individual } = getProperties(
      this,
      'reportChangeset',
      'individual',
    );
    let reportId = get(reportChangeset, 'id');
    let report = get(individual, 'sortedReports').find(
      (x) => x.id === reportId,
    );
    return individual.previousReport(report);
  }),

  errorMessage: computed('checkForErrors', function () {
    let errors = get(
      this,
      'reportChangeset.error.sectionFieldValues.validation',
    );
    if (isEmpty(errors)) {
      return undefined;
    }
    let message = undefined;
    let fieldId = get(this, 'field.id');
    let errorMessages = errors[0].split('|');
    errorMessages.forEach((error) => {
      let errorFieldId = error.split(':')[0];
      if (errorFieldId === fieldId) {
        message = error.split(':')[1].trim();
      }
    });
    return message;
  }),
});
